var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-profile tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("本人資料")]), _c('div', {
    staticClass: "profile-card"
  }, [_c('div', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.profileData.name))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("身分證字號")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.maskedIdno))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("出生年月日")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.profileData.birthday))])])]), _c('div', {
    staticClass: "profile-footer"
  }, [_c('div', {
    staticClass: "reminder-green"
  }, [_vm._v(" " + _vm._s(_vm.reminderText) + " ")])])]), _c('div', {
    staticStyle: {
      "padding-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('button', {
    staticClass: "btn btn-secondary w-50",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" 返回 ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }